// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageRadioOption_container__19nAl","icon":"ImageRadioOption_icon__8pQSD","label":"ImageRadioOption_label__1oVRA"};